"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
require("../index.scss");
const ProfileAccountInfoSection_1 = require("@Components/ProfileAccountInfoSection");
const contexts_1 = require("@App/contexts");
const user_1 = require("@App/api/routes/user");
const user_info_schema_1 = require("@Entities/schemas/user/user-info-schema");
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("@hookform/resolvers/zod");
const ContactInfoSection_1 = __importDefault(require("@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserEdit/ContactInfoSection"));
const AddressSection_1 = __importDefault(require("@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserEdit/AddressSection"));
const UserInfoSection_1 = __importDefault(require("@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserEdit/UserInfoSection"));
const TopSection_1 = __importDefault(require("@Scenes/ProfileScene/ProfileSceneUserTab/ProfileSceneUserEdit/TopSection"));
const flatten_object_1 = require("@App/helpers/flatten-object");
const userinfo_to_zod_mapper_1 = require("@App/helpers/userinfo-to-zod-mapper");
const dayjs_1 = __importDefault(require("dayjs"));
const ProfileSceneUserEdit = (props) => {
    const { setEditable } = props;
    const { preloaderStore, popupStore, userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const profileInfo = (0, userinfo_to_zod_mapper_1.userinfoToZodMapper)(userStore.userInfo) || {};
    const methods = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        criteriaMode: 'all',
        resolver: (0, zod_1.zodResolver)(user_info_schema_1.userInfoSchema),
        defaultValues: profileInfo,
    });
    (0, react_1.useEffect)(() => () => {
        setEditable(false);
    }, []);
    const cleanUpData = (data) => {
        const userInfo = (0, flatten_object_1.flattenObject)(data);
        userInfo.country = Number(data.address.countryId);
        userInfo.phoneCountryCode = Number(data.phoneNumber.phoneCountryCode);
        data.settingsForm &&
            (userInfo.settings = [
                {
                    parameter: 'privacyPolicy',
                    value: data.settingsForm.privacyPolicy,
                },
                {
                    parameter: 'emailCommunications',
                    value: data.settingsForm.emailCommunications || false,
                },
                {
                    parameter: 'termsAndConditions',
                    value: data.settingsForm.termsAndConditions,
                },
                {
                    parameter: 'searchTermsAndConditions',
                    value: data.settingsForm.searchTermsAndConditions,
                },
                {
                    parameter: 'showWelcomePopup',
                    value: data.settingsForm.showWelcomePopup,
                },
                {
                    parameter: 'mfaBySms',
                    value: data.settingsForm.mfaBySms,
                },
                {
                    parameter: 'mfaByEmail',
                    value: data.settingsForm.mfaByEmail,
                },
                {
                    parameter: 'showDetailedWorkCards',
                    value: data.settingsForm.showDetailedWorkCards,
                },
            ]);
        userInfo.birthday = (0, dayjs_1.default)(data.birthday).format();
        return userInfo;
    };
    const saveInfo = (data) => __awaiter(void 0, void 0, void 0, function* () {
        if (data) {
            try {
                preloaderStore.openTransparentPreloader(true);
                const editUser = cleanUpData(data);
                yield (0, user_1.editUserInfo)(editUser);
                yield userStore.loadUserInfo();
                setEditable(false);
                preloaderStore.openTransparentPreloader(false);
                popupStore.setAlertData('Profile updated', false);
            }
            catch (error) {
                preloaderStore.openTransparentPreloader(false);
                popupStore.setAlertFromError(error);
            }
        }
    });
    const { firstName, lastName, birthday, email, address, phoneNumber } = user_info_schema_1.userInfoFormFields;
    return (react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
        react_1.default.createElement("form", { onSubmit: methods.handleSubmit(saveInfo) },
            react_1.default.createElement("div", { className: 'profile-scene-user-tab' },
                react_1.default.createElement(TopSection_1.default, { startedProfileInfo: profileInfo, setNonEditable: () => setEditable(false), disabled: !methods.formState.isDirty }),
                react_1.default.createElement(ProfileAccountInfoSection_1.ProfileAccountInfoSection, { userInfo: profileInfo }),
                react_1.default.createElement(UserInfoSection_1.default, { firstName: firstName, lastName: lastName, birthday: birthday }),
                react_1.default.createElement(AddressSection_1.default, { addressForm: address }),
                react_1.default.createElement(ContactInfoSection_1.default, { email: email, phoneNumberForm: phoneNumber, disableEmail: true })))));
};
exports.default = ProfileSceneUserEdit;
